/**
 * Created by fers on 05.02.16.
 */

import PureRenderMixin from 'react-addons-pure-render-mixin';
import {FormattedMessage} from 'react-intl';

import React from 'react';

export default class extends React.Component {
    constructor() {
        super();
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }


    render() {
        return (
            <div><h3><span className="fa fa-exclamation-circle"/> <FormattedMessage defaultMessage="Not enough Permission" id="permission.notEnough" /></h3></div>
        );
    }
}
